// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl-checkbox__wrapper[data-v-c8fa2a02] {
  padding: 5px 0 4px;
}
.vl-checkbox__wrapper__indent[data-v-c8fa2a02] {
  margin: 10px 0 10px 30px;
}
[data-v-c8fa2a02] .vl-checkbox--disabled .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::before {
  color: #707070;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
